var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"nav-tabs"},_vm._l((_vm.tabList),function(ref){
var disabled = ref.disabled;
var key = ref.key;
var name = ref.name;
return _c('li',{key:key,class:{ disabled: disabled, active: key == _vm.selectedTab }},[_c('a',{on:{"click":function($event){if (!disabled) {
            _vm.selectedTab = key
          }}}},[_vm._v(_vm._s(name))])])}),0),_c('div',{staticClass:"tab-content"},_vm._l((_vm.tabList),function(ref,i){
          var key = ref.key;
return _c('div',{key:key},[(key == _vm.selectedTab)?_vm._t(("tab-" + i)):_vm._e()],2)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }